module.exports = __webpack_public_path__ + "static/media/soma11.3d833993.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ParkingLots/Instructions/SF/soma11.png
// module id = 2227
// module chunks = 0